var map = {
	"./accordion-icon.svg": "./node_modules/raw-loader/index.js!./src/icons/accordion-icon.svg",
	"./back-arrow.svg": "./node_modules/raw-loader/index.js!./src/icons/back-arrow.svg",
	"./close-icon.svg": "./node_modules/raw-loader/index.js!./src/icons/close-icon.svg",
	"./down-arrow.svg": "./node_modules/raw-loader/index.js!./src/icons/down-arrow.svg",
	"./dropdown-bars.svg": "./node_modules/raw-loader/index.js!./src/icons/dropdown-bars.svg",
	"./flag-icon.svg": "./node_modules/raw-loader/index.js!./src/icons/flag-icon.svg",
	"./forward-arrow.svg": "./node_modules/raw-loader/index.js!./src/icons/forward-arrow.svg",
	"./gallery-icon.svg": "./node_modules/raw-loader/index.js!./src/icons/gallery-icon.svg",
	"./gallery_icon.svg": "./node_modules/raw-loader/index.js!./src/icons/gallery_icon.svg",
	"./maroon.svg": "./node_modules/raw-loader/index.js!./src/icons/maroon.svg",
	"./white-flag-icon.svg": "./node_modules/raw-loader/index.js!./src/icons/white-flag-icon.svg",
	"./white.svg": "./node_modules/raw-loader/index.js!./src/icons/white.svg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1;



//////////////////
// WEBPACK FOOTER
// ./src/icons ./~/raw-loader!^\.\/.*\.svg$
// module id = 1
// module chunks = 168707334958949